import { firstValueFrom } from 'rxjs';
import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { AssetHyperlinksComponent } from "@app/assetmanagement/components/asset-hyperlinks/asset-hyperlinks.component";
import { ToggleGroupComponent } from "@app/shared/organisms/toggle-group/toggle-group.component";
import { provideTranslocoScope, TranslocoPipe, TranslocoService } from "@jsverse/transloco";
import { AssetManagementModel } from "@models/assetmanagement/assetmanagementmodel";

@Component({
    selector: "app-asset-document-hyperlink-toggle",
    templateUrl: "./asset-document-hyperlink-toggle.component.html",
    imports: [ToggleGroupComponent, AssetHyperlinksComponent, TranslocoPipe],
    providers: [provideTranslocoScope("assetmanagement")],
})
export class AssetDocumentHyperlinkToggleComponent implements OnInit{
    @Input() model: AssetManagementModel;
    @Input() canEdit: boolean = true;
    @Output() hyperlinksChanged: EventEmitter<AssetManagementModel> = new EventEmitter<AssetManagementModel>();

    protected selectedTab: string = "hyperlinks";

    private _transloco = inject(TranslocoService);
    

    async ngOnInit(): Promise<void> {
        await firstValueFrom(this._transloco.load(`assetmanagement/${this._transloco.getActiveLang()}`));
    }
}
    